'use strict';

$ = jQuery;

$('#card-list-brand-slider').slick({
  dots: true,
  arrows: true,
  infinite: true,
  speed: 300,
  slidesToShow: 6,
  slidesToScroll: 6,
  autoplay: false,
  adaptiveHeight: false,
  lazyLoad: 'ondemand',
  responsive: [{
    breakpoint: 1024,
    settings: 'unslick'
  }]
});